import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, type CSSResult } from 'lit'

export const tierPricingStyle: CSSResult = css`
  :host {
    --cse-divider-width: 1px;
    --cse-badge-min-height: 21px;
  }

  .tier-list {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing04};
  }

  .tier {
    display: flex;
    align-items: center;
    gap: ${csSpacing.spacing05};
    width: 100%;
  }

  .tier-price-info {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  cse-divider {
    align-self: stretch;
  }
`
